import React from "react";
import { IconSize, IconProps } from "../theme";

const Attorney: React.FC<IconProps> = ({ size = IconSize.M }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
    >
      <circle cx="9" cy="4.5" r="4.5" fill="#071443" />
      <path
        fill="#071443"
        d="M7.87 18v-6.75h2.26V18l2.26-7.5s4.522 1.5 5.275 2.25 0 5.25 0 5.25H.335s-.754-4.5 0-5.25c.753-.75 5.274-2.25 5.274-2.25z"
      />
    </svg>
  );
};

export default Attorney;
